<template>
<div>
    <el-drawer
        :title="title"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        append-to-body
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <table v-if="data" class="info-table" style="width:100%">
                <tr>
                    <th>申请申请人</th>
                    <td>{{data.applyUser}}</td>
                </tr>
                <tr>
                    <th>申请取消时间</th>
                    <td>{{data.applyTime}}</td>
                </tr>
                <tr>
                    <th>取消逻辑</th>
                    <td>{{data.type == 1 ? "保留演出, 订单全退" : "取消演出及所有订单"}}</td>
                </tr>
                <tr>
                    <th>取消范围</th>
                    <td><div v-for="(item,index) in data.cancelRange" :key="index">{{item}}</div></td>
                </tr>
                <tr>
                    <th>取消原由</th>
                    <td>{{data.cancelReason}}</td>
                </tr>
				<tr>
				    <th>外部销售</th>
				    <td><div v-for="(item,index) in data.pushThirdList" :key="index">{{item}}</div></td>
				</tr>
                <tr>
                    <th>取消函</th>
                    <td><el-button v-if="data.cancelLetterUrl" type="text" @click="showViewer=true" size="mini">点击查看</el-button></td>
                </tr>
                <tr v-if="data.checkRemark">
                    <th>初审备注</th>
                    <td>{{data.checkRemark}}</td>
                </tr>
                <tr v-if="data.recheckRemark">
                    <th>复审备注</th>
                    <td>{{data.recheckRemark}}</td>
                </tr>
                <tr>
                    <th>审核进度</th>
                    <td :class="status[data.status].class">
                        {{status[data.status].text}}
                    </td>
                </tr>
                <tr v-if="data.status == 0 || data.status == 1">
                    <th>{{data.status == 0 ? '初审' : '复审'}}备注</th>
                    <td><el-input type="textarea" v-model="formData.remark" :rows="4" maxlength="100" show-word-limit></el-input></td>
                </tr>
            </table>
        </div>
        <div class="drawer-footer">
            <template v-if="data">
                <el-button v-if="$utils.have('/activity/cancel/check') && data.status == 0" type="primary" @click="check(1)" v-loading="btnLoading">初审通过</el-button>
                <el-button v-if="$utils.have('/activity/cancel/recheck') && data.status == 1" type="primary" @click="check(1)" v-loading="btnLoading">复审通过</el-button>
                <el-button v-if="($utils.have('/activity/cancel/check') || $utils.have('/activity/cancel/recheck')) && (data.status == 0 || data.status == 1)" type="danger" @click="check(0)" v-loading="btnLoading">拒绝</el-button>
            </template>
            <el-button @click="close()">关闭</el-button>
        </div>
    </el-drawer>
    <el-image-viewer v-if="showViewer && data.cancelLetterUrl" :on-close="closeViewer" :url-list="[data.cancelLetterUrl]" :z-index="100000"/>
</div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    components:{ElImageViewer},
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            applyId: "",
            data: null,
            showViewer: false,
            btnLoading: false,
            formData:{
                remark: '',
                isPass: 1
            }
        }
    },
    computed:{
        status(){
            return {
                0: {text: "待初审", class: "color-warning"},
                1: {text: "待复审", class: "color-warning"},
                2: {text: "已通过", class: "color-success"},
                3: {text: "已拒绝", class: "color-danger"},
                4: {text: "已撤销", class: "color-info"},
            }
        },
        title(){
            let _title = "审核进度"
            if( this.data && this.data.status == 0 ){
                _title = "初审"
            }
            if( this.data && this.data.status == 1 ){
                _title = "复审"
            }
            return _title;
        }
    },
    methods:{
        close(){
            this.formData.remark = "";
            this.drawerShow = false;
        },
        show(id){
            this.applyId = id;
            this.applyDetail();
            this.drawerShow = true;
        },
        //获取详情
        applyDetail(){
            this.dataLoading = true;
            this.$request({
                url: "/activity/cancel/applyDetail",
                params: { id: this.applyId },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        closeViewer(){
            this.showViewer = false
        },
        check(isPass){
            this.btnLoading = true;
            this.$request({
                url: this.data.status == 0 ? "/activity/cancel/check" : "/activity/cancel/recheck",
                params: { 
                    ...this.formData,
                    isPass : isPass,
                    id: this.data.id
                 },
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$emit('onUpdate');
                        this.close();
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>